
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignFoundationsMotion',
  components: { DesignContentLayout }
};
